import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurationComponent } from './configuration.component';
import { ComponentsModule } from '../../../components/components.module';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RouterModule } from '@angular/router';
import { ConfigurationEditComponent } from './configuration-edit/configuration-edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { TagModule } from 'primeng/tag';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { PipesModule } from '../../../pipes/pipes.module';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [ConfigurationComponent, ConfigurationEditComponent],
  imports: [
    CommonModule,
    ComponentsModule,
    TableModule,
    ButtonModule,
    ToastModule,
    ConfirmDialogModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    CheckboxModule,
    TagModule,
    DropdownModule,
    InputNumberModule,
    PipesModule,
    TooltipModule,
    TranslateModule
  ],
  exports: [ConfigurationComponent]
})
export class ConfigurationModule { }
